import styled from 'styled-components';

export const Image = styled.img`
  cursor: pointer;
`;
